/**
 * Sinewav3 Visualizer
 * Copyright (c) 2016-2017 Futurescale, Inc.
 *
 * Define FSM Constants
 */
(function() {

    // Initialize the namespace
    sinewav3.fsm = {
        action: {},
        state: {},
        announce: {},
        config: {}
    };

    // Configure actions
    const action = sinewav3.fsm.action,
        FSM_ACTION = "FSM/action/";

    action.PREPARE   = FSM_ACTION + "prepare";
    action.VIEW      = FSM_ACTION + "view";
    action.ANALYZE   = FSM_ACTION + "analyze";
    action.RENDER    = FSM_ACTION + "render";
    action.VISUALIZE = FSM_ACTION + "visualize";
    action.PAUSE     = FSM_ACTION + "pause";
    action.RESUME    = FSM_ACTION + "resume";
    action.CLOSE     = FSM_ACTION + "close";
    action.DESTROY   = FSM_ACTION + "destroy";
    action.WAIT      = FSM_ACTION + "wait";

    // Configure states
    const state   = sinewav3.fsm.state,
        FSM_STATE = "FSM/state/";

    state.WAITING     = FSM_STATE + "waiting";
    state.VIEWING     = FSM_STATE + "viewing";
    state.PREPARING   = FSM_STATE + "preparing";
    state.ANALYZING   = FSM_STATE + "analyzing";
    state.RENDERING   = FSM_STATE + "rendering";
    state.VISUALIZING = FSM_STATE + "visualizing";
    state.PAUSING     = FSM_STATE + "pausing";
    state.RESUMING    = FSM_STATE + "resuming";
    state.CLOSING     = FSM_STATE + "closing";
    state.DESTROYING  = FSM_STATE + "destroying";

    // Configure announcements
    const announce = sinewav3.fsm.announce,
        FSM_ANNOUNCE  = "FSM/announce/",
        CHANGED       = FSM_ANNOUNCE + "changed/",
        GUARD         = FSM_ANNOUNCE + "guard/",
        ENTER         = GUARD + "enter/",
        EXIT          = GUARD + "exit/";

    // State-specific 'changed' announcements,
    // sent when the transition to the new state is complete
    announce.CHANGED_WAITING     = CHANGED + "waiting";
    announce.CHANGED_PREPARING   = CHANGED + "preparing";
    announce.CHANGED_VIEWING     = CHANGED + "viewing";
    announce.CHANGED_ANALYZING   = CHANGED + "analyzing";
    announce.CHANGED_RENDERING   = CHANGED + "rendering";
    announce.CHANGED_VISUALIZING = CHANGED + "visualizing";
    announce.CHANGED_PAUSING     = CHANGED + "pausing";
    announce.CHANGED_RESUMING    = CHANGED + "resuming";
    announce.CHANGED_CLOSING     = CHANGED + "closing";
    announce.CHANGED_DESTROYING  = CHANGED + "destroying";

    // State-specific 'exiting' announcements,
    // sent when the transition from the current state begins, allowing cancel
    announce.ENTER_CLOSING = ENTER + state.CLOSING;
    announce.EXIT_DESTROYING = EXIT + state.DESTROYING;

    // Configure finite state machine
    sinewav3.fsm.config =
    {
        "@initial": state.WAITING,
        "state": [
            {
                "@name": state.WAITING,
                "@changed": announce.CHANGED_WAITING,
                "transition": [
                    {
                        "@action": action.PREPARE,
                        "@target": state.PREPARING
                    }
                ]
            },
            {
                "@name": state.PREPARING,
                "@changed": announce.CHANGED_PREPARING,
                "transition": [
                    {
                        "@action": action.ANALYZE,
                        "@target": state.ANALYZING
                    },
                    {
                        "@action": action.VISUALIZE,
                        "@target": state.VISUALIZING
                    },
                    {
                        "@action": action.RENDER,
                        "@target": state.RENDERING
                    },
                    {
                        "@action": action.VIEW,
                        "@target": state.VIEWING
                    }
                ]
            },
            {
                "@name": state.VIEWING,
                "@changed": announce.CHANGED_VIEWING,
                "transition": [
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    }
                ]
            },
            {
                "@name": state.VISUALIZING,
                "@changed": announce.CHANGED_VISUALIZING,
                "transition": [
                    {
                        "@action": action.PAUSE,
                        "@target": state.PAUSING
                    },
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    }
                ]
            },
            {
                "@name": state.PAUSING,
                "@changed": announce.CHANGED_PAUSING,
                "transition": [
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    },
                    {
                        "@action": action.RESUME,
                        "@target": state.RESUMING
                    }
                ]
            },
            {
                "@name": state.RESUMING,
                "@changed": announce.CHANGED_RESUMING,
                "transition": [
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    },
                    {
                        "@action": action.VISUALIZE,
                        "@target": state.VISUALIZING
                    }
                ]
            },
            {
                "@name": state.RENDERING,
                "@changed": announce.CHANGED_RENDERING,
                "transition": [
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    }
                ]
            },
            {
                "@name": state.ANALYZING,
                "@changed": announce.CHANGED_ANALYZING,
                "transition": [
                    {
                        "@action": action.CLOSE,
                        "@target": state.CLOSING
                    }
                ]
            },
            {
                "@name": state.CLOSING,
                "@changed": announce.CHANGED_CLOSING,
                "@entering": announce.ENTER_CLOSING,
                "transition": [
                    {
                        "@action": action.DESTROY,
                        "@target": state.DESTROYING
                    }
                ]
            },
            {
                "@name": state.DESTROYING,
                "@changed": announce.CHANGED_DESTROYING,
                "@exiting": announce.EXIT_DESTROYING,
                "transition": [
                    {
                        "@action": action.WAIT,
                        "@target": state.WAITING
                    }
                ]
            }
        ]
    };

})();